var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderBy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Q2",
    "data-name": "icons Q2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.013,
    height: 11.013,
    viewBox: "0 0 11.013 11.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_49",
    "data-name": "Trazado 49",
    d: "M14.462,41.1H4.551a.551.551,0,1,1,0-1.1h9.912a.551.551,0,1,1,0,1.1Z",
    transform: "translate(-4 -30.088)",
    fill: "#2C3D71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_50",
    "data-name": "Trazado 50",
    d: "M12.166,9.919l2.753,2.726a.523.523,0,0,0,.771,0l2.753-2.726a.578.578,0,0,0,.055-.743.523.523,0,0,0-.826-.055l-1.817,1.817V4.551a.551.551,0,0,0-1.1,0v6.388L12.937,9.121a.523.523,0,0,0-.826.055A.578.578,0,0,0,12.166,9.919Z",
    transform: "translate(-9.798 -4)",
    fill: "#2C3D71"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderBy);
export default __webpack_public_path__ + "static/media/orderBy.4788fc47.svg";
export { ForwardRef as ReactComponent };